import { BookOpen, Users, Download, Star } from "lucide-react";

const stats = [
  { icon: Download, value: "Free", label: "Ebook & Resources", desc: "Start at zero cost" },
  { icon: BookOpen, value: "25+", label: "Digital Products", desc: "Journals, planners & workbooks" },
  { icon: Star, value: "10", label: "Video Lessons", desc: "In our signature course" },
  { icon: Users, value: "For", label: "Women in STEM", desc: "& all professionals" },
];

const SocialProof = () => {
  return (
    <section data-testid="social-proof" className="py-16 md:py-20" style={{ background: "var(--ll-bg-secondary)" }}>
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 rounded-xl mx-auto flex items-center justify-center mb-3" style={{ background: "white" }}>
                <stat.icon size={18} style={{ color: "var(--ll-green)" }} />
              </div>
              <p className="font-serif text-2xl sm:text-3xl font-semibold" style={{ color: "var(--ll-text)" }}>
                {stat.value}
              </p>
              <p className="text-xs font-medium mt-0.5" style={{ color: "var(--ll-text-secondary)", fontFamily: "'Outfit', sans-serif" }}>
                {stat.label}
              </p>
              <p className="text-[11px] mt-0.5" style={{ color: "var(--ll-text-muted)", fontFamily: "'Outfit', sans-serif" }}>
                {stat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
